module.exports = __webpack_public_path__ + "img/requests.c7fb3f1c.svg";